// Main imports
import Vue from 'vue'
import Vuetify from 'vuetify'

// // Vuetify locales
import en from 'vuetify/es5/locale/en'

const colors = {
  primary: '#48aae0',
  secondary: '#036fa7',
  accent: '#ef7b25'
}

// Create component
Vue.use(Vuetify)

export default new Vuetify({
  lang: {
    locales: { en },
    current: 'en'
  },

  icons: {
    iconfont: 'mdi',
    values: {
      cancel: 'mdi-close',
      prev: 'mdi-chevron-left',
      next: 'mdi-chevron-right'
    }
  },

  theme: {
    dark: false,
    themes: {
      dark: colors,
      light: colors
    },

    options: {
      customProperties: true
    }
  }
})
